module.exports = __webpack_public_path__ + "static/media/clock.263de5cc.svg";